import React from "react";
import { connect } from "react-redux";
import { selectUserProfile } from "vrcore-dashboard/dist/Dashboard/Router/selectors";
import { Row, Col } from "reactstrap";
import ReactMarkdown from "react-markdown";
import { Button, Typography } from "@material-ui/core";
import { updateAgreement, getAppURL, setSecurity } from "./actions.js";
import { selectLink } from "./selectors.js";
import moment from "moment";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
const webpackMarkdownLoader = require.context("!raw-loader!./", false, /\.md$/);

class EULA extends React.Component {
    constructor(props) {
        super(props);
        const EulaText = webpackMarkdownLoader
            .keys()
            .map((filename) => webpackMarkdownLoader("./EULA.md"));

        this.state = {
            EulaText,
        };
        if (!this.notAgreed()) {
            this.props.setSecurity(this.props.profile);
        }
        props.getAppURL();
    }

    notAgreed() {
        if (
            this.props.profile.agreed_to_eula === "No" ||
            this.props.profile.agreed_to_eula_timestamp === ""
        )
            return false;
        else return true;
    }

    render() {
        return (
            <StyledCard>
                <div>
                    <Row>
                        <Col>
                            <StyledHeader>
                                <Typography variant="h5">EULA</Typography>
                            </StyledHeader>
                            <StyledContent>
                                <StyledViewContainer>
                                    {(this.props.profile.agreed_to_eula ===
                                        "No" ||
                                        this.props.profile
                                            .agreed_to_eula_timestamp ===
                                            "") && (
                                        <div>
                                            <Typography>
                                                Before you gain access to the
                                                App or Dashboard, you must Agree
                                                to the EULA below. Please select
                                                "I Agree" to acknowledge and
                                                accept this licence agreement.{" "}
                                            </Typography>
                                            <Button
                                                color="primary"
                                                onClick={() => {
                                                    let profile = this.props
                                                        .profile;
                                                    let date = moment().format(
                                                        "DD-MM-YYYY, hh:mm:ss"
                                                    );
                                                    profile["agreed_to_eula"] =
                                                        "Yes";
                                                    profile[
                                                        "agreed_to_eula_timestamp"
                                                    ] = date;
                                                    this.props.updateAgreement(
                                                        profile,
                                                        profile.uid
                                                    );
                                                }}
                                                variant="contained"
                                            >
                                                I AGREE
                                            </Button>
                                            <br />
                                            <br />
                                        </div>
                                    )}
                                    <span>
                                        We licence use of the App and Documents
                                        to you on the basis of this EULA and
                                        subject to any rules or policies applied
                                        by the Google Android application store
                                        from whose site, located at{" "}
                                        {this.props.link !== null ? (
                                            <a href={this.props.link}>
                                                {" " + this.props.link}
                                            </a>
                                        ) : (
                                            "[NO LINK CURRENTLY AVAILABLE]"
                                        )}{" "}
                                        (Appstore), the End-user downloaded the
                                        App (Appstore Rules), or the APK send
                                        directly to you. We and/or the owners of
                                        the App and Documents remain the owners
                                        of the App and Documents at all times."
                                    </span>
                                    <ReactMarkdown
                                        source={this.state.EulaText[0]}
                                    />
                                </StyledViewContainer>
                            </StyledContent>
                        </Col>
                    </Row>
                </div>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            profile: selectUserProfile(store),
            link: selectLink(store),
        };
    },
    {
        updateAgreement,
        getAppURL,
        setSecurity,
    }
)(EULA);
